import React, { useState, useEffect } from "react";
import { Form, Input, Button, Modal, Result, Flex, Spin } from "antd";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import {
  resetDeviceRequest,
  resetLoadingDevice,
  resetMessageDevice,
  resetSuccessDevice,
} from "../slices/device";
import { useTypedSelector } from "../store";

const ResetDeviceId: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [employeeId, setEmployeeId] = useState<string>("");
  const [isModal, setIsModal] = useState<boolean>(false);

  const { message, isLoading, isSuccess, isChange } = useTypedSelector(
    (state) => {
      return {
        message: state.Device.message,
        isLoading: state.Device.pageIsLoading,
        isSuccess: state.Device.isSuccess,
        isChange: state.Device.resetData,
      };
    }
  );

  console.log("MSG", message);

  useEffect(() => {
    setEmployeeId("");
  }, [isChange, message, isSuccess]);

  const onFinish = (values: { employeeId: string }) => {
    console.log("Form Values:", values);
    setEmployeeId(values.employeeId.toUpperCase().trim());
    setIsModal(true);
  };

  return (
    <div style={{ width: 200, margin: "0 auto", padding: "0 auto" }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        {/* Input Employee ID */}
        <Form.Item
          label="Employee ID"
          name="employeeId"
          rules={[
            { required: true, message: "Please input your Employee ID!" },
          ]}
        >
          <Input placeholder="Enter Employee ID" />
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
            {!isLoading && <>Reset</>}
            {isLoading && (
              <>
                <Flex align="center" gap="middle">
                  <Spin indicator={<LoadingOutlined spin />} size="small" />
                </Flex>
              </>
            )}
          </Button>
        </Form.Item>
      </Form>

      <Modal
        title="Reset Confirm"
        open={isModal}
        onCancel={() => {
          setEmployeeId("");
          setIsModal(false);
        }}
        onOk={() => {
          setIsModal(false);
          dispatch(resetDeviceRequest({ employeeId: employeeId }) as any);
        }}
      >
        <p>Reset Device ID to Employee {employeeId}</p>
        <p>Are you sure?</p>
      </Modal>
      <Modal
        open={isSuccess}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
      >
        <Result
          status="success"
          title="Reset Device ID Successfully"
          subTitle=""
          extra={[
            <Button
              type="primary"
              onClick={() => {
                // setFileList([])
                dispatch(resetLoadingDevice());
                dispatch(resetMessageDevice());
                dispatch(resetSuccessDevice());
                form.resetFields();
              }}
            >
              Close
            </Button>,
          ]}
        />
      </Modal>
      <Modal
        open={message.length > 0}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
      >
        <Result
          status="warning"
          title="Reset Device ID Warning"
          subTitle={message}
          extra={[
            <Button
              type="primary"
              onClick={() => {
                dispatch(resetLoadingDevice());
                dispatch(resetMessageDevice());
                form.resetFields();
              }}
            >
              Close
            </Button>,
          ]}
        />
      </Modal>
    </div>
  );
};

export default ResetDeviceId;
